import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const canActivateResetPasswordPage: CanActivateFn = (route, state) => {
  const userId = route.queryParamMap.get('id');
  const token = route.queryParamMap.get('token');
  const router = inject(Router);

  if (!userId || !token) {
    return router.navigate(['/']);
  }
  return true;
};
